/**
 * Lead pedido pela URL — `/funil?lead=<id>`.
 *
 * É o link que o painel da conversa oferece ("Abrir no funil"). Puro: recebe
 * o `URLSearchParams` e devolve o id limpo ou `null`. Id é um segmento de
 * documento do Firestore: só letras, dígitos, `_` e `-`; qualquer outra coisa
 * é lixo de URL e não abre painel nenhum.
 */
export function leadDaUrl(params) {
  const bruto = String(params?.get?.('lead') ?? '').trim();
  return /^[A-Za-z0-9_-]{1,128}$/.test(bruto) ? bruto : null;
}
